<template>
  <v-row v-if="doc">
    <div
      v-for="card in doc.selectedTiles"
      :key="card.id"
      :data-id="card.id"
      :style="{ width: computedWidh }"
    >
      <show-card :card="card"></show-card>
    </div>
  </v-row>
</template>

<script>
import ShowCard from "@/components/core/ShowCard";
const fb = require("@/firebaseConfig.js");

export default {
  name: "TilesViewer",
  data() {
    return {
      cols: 4,
      doc: null
    };
  },
  props: {
      uid: String
  },
  components: {
    ShowCard,
  },
  watch: {
    uid() {
        this.getExercise();
    }
  },
  methods: {
    getExercise() {
        console.log('get exercise', this.uid)
      // get a ref to the exercise and listen to changes
      let ref = fb.tilesExCollection.where(
        "uid",
        "==",
        this.uid
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0];
            if (items[0].cols) {
                this.cols = items[0].cols;
            }
          }
        })
        .catch(function() {});
    }
  },
  computed: {
      computedWidh() {
      switch (this.cols) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.33%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.666666666666667%";
        case 7:
          return "14.285714285714286%";
        case 8:
          return "12.5%";
        case 9:
          return "11.111111111111111%";
        case 10:
          return "10%";
        default:
          return "25%";
      }
    }
  }
};
</script>
